export default __webpack_public_path__ + "static/media/XS4 One.b5eba8e4.jpg";